import { ERROR_CODES } from "./errors.js";
export const SUPPORTED_PROTOCOL_VERSIONS = Object.freeze([1]);
export const isSupportedVersion = (v) => typeof v === "number" && SUPPORTED_PROTOCOL_VERSIONS.includes(v);
const refuse = (code, cid) => ({
    ok: false,
    error: { t: "error", code, retryable: ERROR_CODES[code].retryable, ref: { cid } },
});
/** Check the first event of a socket. */
export function handshake(first) {
    if (first.t !== "hello")
        return refuse("protocol.hello-required", first.cid);
    if (!isSupportedVersion(first.v))
        return refuse("protocol.unsupported-version", first.cid);
    return { ok: true };
}
export function createHandshakeGate() {
    let helloSeen = false;
    return {
        check(event) {
            if (helloSeen)
                return { ok: true };
            const r = handshake(event);
            if (r.ok)
                helloSeen = true;
            return r;
        },
        get helloSeen() {
            return helloSeen;
        },
    };
}
//# sourceMappingURL=handshake.js.map